/* global ALKMaps */
import _ from "lodash";

export function getRoutePings(latLonArray) {
  return _.map(latLonArray, (latLon) => {
    return {
      Lon: latLon[0],
      Lat: latLon[1]
    };
  });
}

export function getMercPoints(results, mapUtilities) {
  const points = [];
  for (const coords of results.geometry.coordinates) {
    for (const innerCoords of coords) {
      const merc = mapUtilities.LLtoMerc(innerCoords[0], innerCoords[1]);
      const point = new ALKMaps.Geometry.Point(merc.lon, merc.lat);
      points.push(point);
    }
  }
  return points;
}
// deep clean null or undefined keys
export function removeEmptyProp(obj) {
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === "object") removeEmptyProp(obj[key]); // recursive
    else if (obj[key] == null || obj[key] == undefined) delete obj[key]; // delete
  });
  return obj;
}

export function buildDefaultRoutingProfile(latLonArray, offRouteMiles, region) {
  return {
    RoutePings: getRoutePings(latLonArray),
    OffRouteMiles: offRouteMiles,
    HighwayOnly: false,
    Region: region,
    RoutingOptions: {
      VehicleType: 2,
      RoutingType: 1,
      HighwayOnly: false,
      UseAvoidsAndFavors: false,
      ClassOverrides: 0,
      DistanceUnits: 0,
      TollDiscourage: false,
      BordersOpen: true,
      OverrideRestrict: false, // default is false, see: SWFV-399
      HazMatType: 0,
      RouteOptimization: 0,
      HubRouting: false,
      FerryDiscourage: false,
      sideOfStreetAdherence: 0
    }
  };
}

//These objects map the fleetportal routing profile WS response object string to the ALKMaps derived route input
//See RoutingProfile.cs for the keys
export const routingProfileProps = {
  vehicleTypes: {
    Truck: 0,
    MidsizeTruck: 1,
    LightDuty: 1,
    Auto: 2
  },
  truckStyles: {
    Truck: 4,
    MidsizeTruck: 3,
    LightDuty: 2,
    Auto: 1
  },
  routingTypes: {
    Practical: 0,
    Shortest: 1,
    Fastest: 2,
    "0": 0, // Practical/Quickest
    "1": 1, // Shortest
    "3": 2 // Fastest(Enable Active Routes + Practical/Quickest)
  },
  classOverrides: {
    None: 0,
    NationalNetwork: 1,
    FiftyThreeFoot: 2,
  },
  distanceUnits: {
    Miles: 0,
    Kilometers: 1
  },
  hazmatTypes: {
    None: 0,
    General: 1,
    Caustic: 2,
    Explosives: 3,
    Flammable: 4,
    Inhalants: 5,
    Radioactive: 6,
  },
  unitTypes: {
    English: 0,
    Metric: 1
  }
}



// WEBPACK FOOTER //
// ./app/compliance/compliance.helpers.js